import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './styles.scss';
import PagerArrow from './PagerArrow';
import {
    BET_HISTORY_MAX_PAGES_COUNT,
} from '../../bookmakersSwitcher/accountPage/betHistory.constants';

const Pager = (props) => {
    const {
        isLoading,
        currentPage,
        pageLength,
        currentPageLength,
        hasNextPage,
        onDecrementPage,
        onIncrementPage,
    } = props;
    const lastPage = currentPage === BET_HISTORY_MAX_PAGES_COUNT + 1;

    return (
        <div
            className={
                classNames(
                    'bs-pager',
                    { 'bs-pager_hidden': (currentPage === 1 && !hasNextPage) },
                )
            }
        >
            <PagerArrow
                onArrowClick={onDecrementPage}
                disabled={currentPage === 1}
                iconName="left"
            />
            <div
                className={
                    classNames(
                        'bs-pager__numbers',
                        { 'bs-pager__numbers_hidden': lastPage },
                    )
                }
            >
                {
                    isLoading
                        ? null
                        : `${((currentPage - 1) * pageLength) + 1} - ${
                              ((currentPage - 1) * pageLength) + currentPageLength}`
                }
            </div>
            <PagerArrow
                onArrowClick={onIncrementPage}
                disabled={!hasNextPage}
                iconName="right"
            />
        </div>
    )
}

Pager.defaultProps = {
    hasNextPage: false,
}

Pager.propTypes = {
    isLoading: PropTypes.bool.isRequired,
    currentPage: PropTypes.number.isRequired,
    pageLength: PropTypes.number.isRequired,
    currentPageLength: PropTypes.number.isRequired,
    hasNextPage: PropTypes.bool,
    onDecrementPage: PropTypes.func.isRequired,
    onIncrementPage: PropTypes.func.isRequired,
}

export default Pager



// WEBPACK FOOTER //
// /src/js/common/pager/Pager.jsx